import type {
  IOtherLocaleUrlsContext,
  IOtherLocaleUrlsContextIncomplete,
  LocaleString,
} from '@dreamstack/i18n'
import { RouterOutputs } from '@dreamstack/trpc/client'
import findKey from 'lodash/findKey'
import type { LEXICON_LETTER_TYPE } from './lexiconUrls.static'
import { LEXICON_LETTERS_LOWER } from './lexiconUrls.static'

export type GetLexiconPathOptions = {
  locale: LocaleString
  lexiconLetter: string
  slug: string
}

export const lexiconBaseUrls: { [key: string]: string } = {
  de: `/${process.env.NEXT_PUBLIC_NEWS_BASE_URL_DE}/${
    process.env.NEXT_PUBLIC_LEXICON_DE || 'lexikon'
  }`,
  en: `/${process.env.NEXT_PUBLIC_NEWS_BASE_URL_EN}/${
    process.env.NEXT_PUBLIC_LEXICON_EN || 'lexicon'
  }`,
}

export const lexiconOtherLocaleUrls: IOtherLocaleUrlsContext = {
  de: { url: lexiconBaseUrls.de },
  en: { url: lexiconBaseUrls.en },
}

export const getLexiconPath = ({
  slug,
  lexiconLetter,
  locale,
}: GetLexiconPathOptions) => {
  const baseUrl = lexiconBaseUrls
  const lexiconLetterUrl = getLexiconLetterUrlPart({ lexiconLetter })

  const path =
    locale === 'de'
      ? `${baseUrl.de}/${lexiconLetterUrl}/${slug}`
      : `${baseUrl.en}/${lexiconLetterUrl}/${slug}`
  return path
}

export const getLexiconPathOtherLocales = (
  lexiconArticle: RouterOutputs['cms']['getLexiconArticle']['article']
) => {
  const deExists = true

  const enExists =
    lexiconArticle?.titleDe !== lexiconArticle.titleEn ||
    lexiconArticle?.slugEn !== lexiconArticle?.slugDe

  const otherLocaleUrls: IOtherLocaleUrlsContextIncomplete = {
    de:
      deExists && lexiconArticle.lexiconLetter && lexiconArticle.slugDe
        ? {
            url: getLexiconPath({
              locale: 'de',
              lexiconLetter: lexiconArticle.lexiconLetter,
              slug: lexiconArticle.slugDe,
            }),
          }
        : null,
    en:
      enExists && lexiconArticle.lexiconLetter && lexiconArticle.slugEn
        ? {
            url: getLexiconPath({
              locale: 'en',
              lexiconLetter: lexiconArticle.lexiconLetter,
              slug: lexiconArticle.slugEn,
            }),
          }
        : null,
  }
  return otherLocaleUrls
}

export const getLexiconLetterUrlPart = ({
  lexiconLetter,
}: Pick<GetLexiconPathOptions, 'lexiconLetter'>) => {
  const index = LEXICON_LETTERS_LOWER.indexOf(
    lexiconLetter.toLowerCase() as LEXICON_LETTER_TYPE[number]
  )
  return LEXICON_LETTERS_LOWER[index]
}

export const getLexiconLetterUrlPartReverse = ({
  lexiconLetterUrl,
}: {
  lexiconLetterUrl: string
  locale: LocaleString
}) => {
  const urlMappings = lexiconLetterUrl
  const lexiconLetter = findKey(urlMappings, (url) => url === lexiconLetterUrl)
  return lexiconLetter
}
